var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignUserProfilePlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 56,
    cy: 56,
    r: 56,
    fill: "#F6EDEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.9993 39.332C51.397 39.332 47.666 43.063 47.666 47.6654C47.666 52.2677 51.397 55.9987 55.9993 55.9987C60.6017 55.9987 64.3327 52.2677 64.3327 47.6654C64.3327 43.063 60.6017 39.332 55.9993 39.332ZM50.9993 47.6654C50.9993 44.9039 53.2379 42.6654 55.9993 42.6654C58.7608 42.6654 60.9993 44.9039 60.9993 47.6654C60.9993 50.4268 58.7608 52.6654 55.9993 52.6654C53.2379 52.6654 50.9993 50.4268 50.9993 47.6654Z",
    fill: "#9E3425"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.9993 70.9987C45.9993 65.4759 50.4765 60.9987 55.9993 60.9987C61.5222 60.9987 65.9993 65.4759 65.9993 70.9987C65.9993 71.9192 66.7455 72.6654 67.666 72.6654C68.5865 72.6654 69.3327 71.9192 69.3327 70.9987C69.3327 63.6349 63.3631 57.6654 55.9993 57.6654C48.6356 57.6654 42.666 63.6349 42.666 70.9987C42.666 71.9192 43.4122 72.6654 44.3327 72.6654C45.2532 72.6654 45.9993 71.9192 45.9993 70.9987Z",
    fill: "#9E3425"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignUserProfilePlaceholder);
export default __webpack_public_path__ + "static/media/signUserProfilePlaceholder.80b46e7dcc3c90fe959181a45539f874.svg";
export { ForwardRef as ReactComponent };